import {
  getPage
} from '@/plugins/PlatformSup.js';

export default {
  data() {
    return {
      pageName: "slide",
      modelList: [{
        name: "幻燈片模式",
        values: "slide",
        page: "slide"
      }, {
        name: "快捷鍵模式",
        values: "hotkey",
        page: "hotkey"
      }, {
        name: "多產品模式",
        values: "multiProduct",
        page: "multiProduct"
      }, {
        name: "單產品模式",
        values: "singleProduct",
        page: "singleProduct"
      }, {
        name: "清單模式",
        values: "list",
        page: "list"
      }],
    }
  },

  computed: {
    getComponentPage() {
      return getPage(this.pageName, "components/webSetting");
    }
  },

  methods: {
    saveWebSetting() {
      console.log("save");
    },

    changePage(page) {
      this.pageName = page;
    }
  },

  mounted() {
    this.$store.dispatch("web/getWebSetting");
  },
}
